/*
 * Copyright (C) 2025 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Injectable } from '@angular/core';
import { BadgeResponse } from '@app/app/shared/models';
import { BadgeDataService, PostBadgeRequest } from '@app/app/shared/services/badge/badge-data.service';
import { ObservableResult } from '@app/app/shared/store';

@Injectable()
export class MockBadgeDataService implements BadgeDataService {
  createBadge(request: PostBadgeRequest, languageCode?: string): ObservableResult<BadgeResponse> {
    return ObservableResult.ofSuccess();
  }

  updateBadge(badgeId: string, request: PostBadgeRequest, languageCode?: string): ObservableResult<BadgeResponse> {
    return ObservableResult.ofSuccess();
  }

  getBadge(playlistUid: string, languageCode?: string): ObservableResult<BadgeResponse> {
    return ObservableResult.ofSuccess();
  }
}
